import { h } from 'preact';
import React, { Component } from 'react';

import { ImageSettings } from './ImageSettings';
import ImageSVG from './Image.svg';
import { useDev } from '../../hooks';

import './Image.css';

export const Image = ({
  component,
  path,
  dev,
  className,
}) => {
  const settings = new ImageSettings(component.settings);
  const { devActions, devClass, pathString } = useDev(path, dev);

  const styles = {
    ...settings.margin,
    ...settings.border,
    cursor: settings.link ? 'pointer' : ''
  };

  /* WIDTH & HEIGHT */
  const { marginLeft, marginRight } = settings.margin;
  styles.width = settings.width.type === 'auto' ? 'auto' : settings.width.value + settings.width.type;
  styles.height = settings.height.type === 'auto' ? 'auto' : settings.height.value + settings.height.type;
  if (settings.width.type === '%') {
    styles.width = `calc(${settings.width.value}% - ${(marginLeft + marginRight)}px`;
  };

  const onClick = () => {
    if (settings.link) {
      window.location.replace(settings.link);
    };
  };

  return (
    <img
      alt=""
      onClick={onClick}
      src={settings.url || ImageSVG}
      path={pathString}
      className={'message-component message-image no-children' + className + devClass}
      style={styles}
      {...devActions}
    />
  );
};